export const LeftArrowIcon = props => (
  <svg
    width={11}
    height={7}
    viewBox='0 0 11 7'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M1 5.75L5.5 1.25L10 5.75'
      stroke='black'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
